import React from "react";
import {
  BrowserRouter,
  Route,
  Link,
  Redirect,
  withRouter
} from "react-router-dom";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import ModelViewerApp from "./ModelViewerApp";
import TestApp from "./TestApp";
import PublicUpload from "./PublicProject/PublicUpload";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
  <BrowserRouter>
    <div>
      <Route path="/private-upload" component={App} />
      <Route path="/private-model-viewer" component={ModelViewerApp} />
      <Route path="/test-upload" component={TestApp} />
      <Route path="/public-upload" component={PublicUploadRouter} />
    </div>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

function PublicUploadRouter() {
  return (
    <PublicUpload
      saveAddCallback={() => {
        console.log("save add callback");
      }}
      classes={{}}
    />
  );
}
